import { css } from '@/styled-system/css';

export const heroContainerStyles = css.raw({
  marginRight: 'auto',
  marginLeft: 'auto',
  textAlign: 'left',
  xl: {
    maxWidth: '511px',
    minWidth: '300px',
    flexBasis: '300px',
    flexGrow: 1,
    marginRight: '0',
    marginLeft: '0',
  },
});

export const infoContainerStyles = css.raw({
  textAlign: 'left',
  height: 'fit-content',
});
